import React from 'react';
import {Icon} from "in-touch-icons";

const InteractiveWebinars = (props) => {

    const {image, title, url} = props.webinarsData;
    const clever = props.clever === true ? 'clever' : '';
    let card;
    
    switch(props.length)
    {
        case 1: card = ''
            break;
        case 2: card = 'col-sm-6'
            break;
        case 3: card = 'col-xl-4'
            break;
        default: card = 'col-sm-6 col-xl-3'
    }

    return (
        <div className={`col-12 ${card} base-card video-card ${clever}`}>
            <button className="card-inner" onClick={()=> props.openModal(url, props.webinarsData)}>
                <div className="theme-video-head">
                    <div className="image" style={{backgroundImage: `url(${image})`}}></div>
                    <div className="play-wrapper">
                        <Icon iconName='play' fill='white' svgClass="play-img icon-secondary"/>
                        <Icon iconName='play' fill='#E84E0F' svgClass="play-img icon-primary"/>
                    </div>
                </div>
                <div className="theme-video-body">
                    <h3 className="heading-three">{title}</h3>
                    <span className="theme-button">Read more</span>
                </div>
            </button>
        </div>
    );
};

export default InteractiveWebinars;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/cards/InteractiveWebinars.js